import React from 'react';

const statusRowBg = {
  coincide: 'bg-green-50',
  no_coincide: 'bg-red-50',
  no_validable: 'bg-yellow-50',
  fijo: 'bg-blue-50',
};

function ComparisonTable({ results }) {
  // Group by seccion preserving order
  const sections = [];
  const sectionMap = {};
  for (const r of results) {
    if (!sectionMap[r.seccion]) {
      sectionMap[r.seccion] = [];
      sections.push({ name: r.seccion, items: sectionMap[r.seccion] });
    }
    sectionMap[r.seccion].push(r);
  }

  return (
    <div className="space-y-6">
      {sections.map(({ name, items }) => (
        <div key={name} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="bg-gold-500 text-white px-5 py-2.5 font-semibold text-sm">
            {name}
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="px-4 py-2 text-left text-xs font-semibold text-gray-500 w-10"></th>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-gray-500 w-16">Campo</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-gray-500">Descripción</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-gray-500">Valor SAE</th>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-gray-500">Valor Esperado</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r, i) => (
                  <tr
                    key={i}
                    className={`border-b border-gray-100 ${statusRowBg[r.status] || ''} hover:brightness-95 transition-colors`}
                  >
                    <td className="px-4 py-2.5 text-center text-base">{r.icon}</td>
                    <td className="px-4 py-2.5 font-bold text-gray-600">{r.campo}</td>
                    <td className="px-4 py-2.5 text-gray-700">{r.label}</td>
                    <td className="px-4 py-2.5 font-mono text-gray-800">
                      {r.valorPDF || <span className="text-gray-300">—</span>}
                    </td>
                    <td className="px-4 py-2.5 font-mono text-gray-600">
                      {r.valorAurum || <span className="text-gray-300">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      {results.length === 0 && (
        <div className="text-center text-gray-400 py-12">
          No hay resultados para este filtro.
        </div>
      )}
    </div>
  );
}

export default ComparisonTable;
